import React, { Fragment, useEffect, useState } from "react";
import { Alert, Backdrop, CircularProgress, Container } from "@mui/material";
import PaymentAccountCredit from "../../components/PaymentAccountCredit";
import {
	ApiCallStatus,
	PaymentMethod, PaymentType
} from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import {
	createAccountCreditPaymentData,
	fetchPaymentOrderData
} from "../PageFunctions/paymentFunctions";
import { useArgusAuth } from "../../hooks/useArgusAuth";


const PaymentAccountCreditPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [paymentOrderInfo, setPaymentOrderInfo] = useState(null);
	const [paymentErrorMessage, setPaymentErrorMessage] = useState("");

	const [paymentOrderInfoCallStatus, setPaymentOrderInfoCallStatus] = useState(ApiCallStatus.NotStarted);
	const [createAccountCreditPaymentCallStatus, setCreateAccountCreditPaymentCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoLoginPage = () => {
		return navigate("/login", {state: {from: location}});
	};

	const gotoPaymentPage = () => paymentOrderInfo?.orderId ? navigate(`/payment`) : navigate(-1);
	const gotoOrderConfirmationPage = (orderId) => navigate(`/order-confirmation/${orderId}`);


	const fetchPaymentOrderDataAsync = async () => {
		await fetchPaymentOrderData({
			paymentType: PaymentType.AccountCredit,
			setPaymentOrderInfo,
			setStatusInProgress: () => setPaymentOrderInfoCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Error)
		});
	};

	const createAccountCreditPaymentDataAsync = async () => {
		setPaymentErrorMessage("");
		await createAccountCreditPaymentData({
			setStatusInProgress: () => setCreateAccountCreditPaymentCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setCreateAccountCreditPaymentCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setCreateAccountCreditPaymentCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setCreateAccountCreditPaymentCallStatus(ApiCallStatus.Error),
			setErrorMessage: setPaymentErrorMessage
		});
	};

	const authorizedPageLoad = async () => {

	};

	const unAuthorizedPageLoad = async () => {
		await fetchPaymentOrderDataAsync();
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			} else {
				authorizedPageLoad();
				unAuthorizedPageLoad();
			}
		}
	}, [genericDataLoaded, isAuthenticated, isLoading]);

	useEffect(() => {
		if (createAccountCreditPaymentCallStatus === ApiCallStatus.Succeeded && !!paymentOrderInfo.orderId) {
			gotoOrderConfirmationPage(paymentOrderInfo.orderId);
		}
	}, [createAccountCreditPaymentCallStatus, paymentOrderInfo]);

	useEffect(() => {
		// if (!!paymentErrorMessage) window.scrollTo(0, 0);
	}, [paymentErrorMessage]);


	const allLoadingStates = [
		paymentOrderInfoCallStatus,
		createAccountCreditPaymentCallStatus,
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			{!!paymentErrorMessage && (
				<Alert severity="warning" sx={{mt: 2, mb: 2}}>
					{paymentErrorMessage}
				</Alert>
			)}
			<PaymentAccountCredit
				paymentOrderInfo={paymentOrderInfo}
                tecfinityAvailableCredit={genericPageContent?.tecfinityAvailableCredit}
                tecfinityCreditLimit={genericPageContent?.tecfinityCreditLimit}
				gotoPaymentPage={gotoPaymentPage}
				onSubmit={createAccountCreditPaymentDataAsync}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};

export default PaymentAccountCreditPage;
